import Grow, { GrowProps } from '@material-ui/core/Grow';

export type DSGrowProps = GrowProps;

export const DSGrow = Grow;
